import { createSlice } from '@reduxjs/toolkit';
import { GetStagingPickListState } from './types';
import { StoreStatus } from '../../core/types/common.types';
import { getStagingPickListThunk } from './thunks';

// Initial State
const initialState: GetStagingPickListState = {
  errors: null,
  status: StoreStatus.IDLE,
  response: null,
};

// Slice
export const getRankedCryoboxesSlice = createSlice({
  name: 'getRankedCryoboxes',
  initialState,
  reducers: {
    setValues: (state, action) => ({
      ...state,
      values: action.payload,
    }),
    reset: () => ({
      ...initialState,
    }),
  },
  extraReducers: (builder) => {
    builder.addCase(getStagingPickListThunk.pending.type, (state) => {
      state.status = StoreStatus.BUSY;
    });
    builder.addCase(getStagingPickListThunk.fulfilled.type, (state, action: any) => {
      state.status = StoreStatus.IDLE;
      state.response = action.payload;
      state.errors = null;
    });
    builder.addCase(getStagingPickListThunk.rejected.type, (state, action: any) => {
      state.status = StoreStatus.ERROR;
      state.errors = action.payload;
      state.response = null;
    });
  },
});

// Action creators
export const { reset, setValues } = getRankedCryoboxesSlice.actions;
export * from './thunks';
export * from './selectors';
export default getRankedCryoboxesSlice.reducer;
